var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: none;\r\n\t\t\tstroke: #332624;\r\n\t\t\tstroke-width: 56;\r\n\t\t\tstroke-miterlimit: 10;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.97,933.31L192.5,643.16c0,0-11.24-32.01,12.03-56.54c0,0,18.92-19.15,57.26-9.85L379.11,711.1 c0,0,16.4,14.33,18.62-18.15l-4.55-449.33c0,0,0.84-46.9,48.65-53.76c0,0,47.86-10.32,62.01,47.83l12.81,308 c0,0-3.98,17.23,37.39,17.33l216.53,7.84c0,0,89.44,0.28,56.26,128.78L756.7,933.4L421.97,933.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.54,376.8l-1.36-133.99c0,0,0.84-46.9,48.65-53.76c0,0,47.86-10.32,62.01,47.83l5.75,138.23 c70.18-20.17,120.44-74.35,120.44-138.03c0-80.89-81.08-146.46-181.1-146.46s-181.1,65.57-181.1,146.46 C267.82,302.63,321.09,358.12,394.54,376.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPress);
export default __webpack_public_path__ + "static/media/icon-press.98f54f71.svg";
export { ForwardRef as ReactComponent };